import React from 'react';
import './CtaSection.css';

const CtaSection = () => {
  return (
    <section className="cta-section">
      <div className="container cta-content">
        <div className="cta-text">
          <h2 className="cta-title">Revolutionize your business operations</h2>
          <p className="cta-subtitle">
            By integrating AI-driven robotics with SAP solutions, ensuring seamless automation and enhanced efficiency.
          </p>
        </div>
        <div className="cta-buttons">
          <a href="/contact-us" className="cta-button primary">Contact Us</a>
          <a href="tel:+919111894443" className="cta-button secondary">Call Us : +91 9111894443</a>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;